import { TopicListType, TopicValueType } from './ContactUsForm.types';

export const TOPIC_LIST: TopicListType[] = [
  { label: 'Select', value: 'NA' },
  { label: 'Copy of Hotel Bill', value: 'FBR' },
  { label: 'Request Credit for a Missing Stay', value: 'MSTA' },
  { label: 'Marriott Bonvoy Account Assistance', value: 'MRMAP' },
  { label: 'Hotel Information (Service, Amenities)', value: 'HI' },
  { label: 'Compliment/Concerns About a Stay', value: 'CCAPHS' },
  { label: 'Credit Card Authorization Form', value: 'CCAF' },
  { label: 'Group Sales', value: 'GMF' },
  { label: 'Meetings and Events', value: 'GEMT' },
  { label: 'Website Support', value: 'MS' },
];

export const FILE_UPLOAD_TOPICS: TopicListType[] = [
  { label: 'Name Change', value: 'NC' },
  { label: 'Deceased Member Account Support', value: 'DMAS' },
  { label: 'Marriott Bonvoy Account Verification', value: 'MBAV' },
];

export const EXCLUDED_TOPICS_FOR_UNAUTH: TopicValueType[] = ['MSTA', 'MRMAP', 'NC', 'DMAS'];
export const CONTACT_INFORMATION_TOPICS: TopicValueType[] = ['FBR', 'GMF', 'GEMT', 'MS', 'NC', 'DMAS', 'MBAV'];
